import React from "react";

import { useSelector } from "react-redux";
import Product from "./Product";

export default function ProductList() {
  const count = useSelector((state) => state);
  const products = count.productReducer;

  return (
    <div class="col-span-12 sm:col-span-12 md:col-span-7 lg:col-span-8 xxl:col-span-8">
      {products?.map((item) => (
        <Product items={item} />
      ))}
    </div>
  );
}
